import React from "react";
import filter from "../../assests/images/filter.svg";

export default function FilterMenuUpload(props) {
  return (
    <>
      <div className="dropdown">
        <button
          className="btn form-label filter-box"
          type="button"
          id="filter"
          data-bs-toggle="dropdown"
          data-bs-auto-close="outside"
          aria-expanded="false"
        >
          <img src={filter} alt="" />
          <span style={{ paddingLeft: "8px" }}>Filter</span>
        </button>
        <ul
          className="dropdown-menu p-3"
          aria-labelledby="filter"
          id="AppDropDownId"
          style={{ minWidth: "13rem" }}
        >
          <li className="sub-step-link">Add Filters</li>
          <li>
            <div className="accordion" id="filterFileType">
              <div className="border-0" style={{ padding: "16px 0 0px 0" }}>
                <span>
                  <button
                    className="accordion-button collapsed no-focus-outline"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFileType"
                    aria-expanded="false"
                    aria-controls="collapseFileType"
                    style={{ padding: "0 0 10px 0" }}
                  >
                    <span
                      className="review-text menu-options"
                      style={{ padding: "0" }}
                    >
                      File Type
                    </span>
                  </button>
                </span>
                <div
                  id="collapseFileType"
                  className="accordion-collapse collapse"
                  data-bs-parent="#filterFileType"
                >
                  <div className="pb-0 px-2">
                    <div className="form-check mb-1">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="fileType"
                        id="bulkExpressionFile"
                        value="Quantified Cell Fraction"
                        checked={
                          props.filters.fileType === "Quantified Cell Fraction"
                        }
                        onClick={(e) =>
                          props.handleFilterChange("fileType", e.target.value)
                        }
                      />
                      <label className="form-check-label sub-text">
                        Quantified Cell Fraction
                      </label>
                    </div>
                    <div className="form-check mb-0 pb-0">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="fileType"
                        id="bulkExpressionFile"
                        value="Bulk Expression File"
                        checked={
                          props.filters.fileType === "Bulk Expression File"
                        }
                        onClick={(e) =>
                          props.handleFilterChange("fileType", e.target.value)
                        }
                      />
                      <label className="form-check-label sub-text">
                        Bulk Expression File
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div className="accordion" id="filterUpload">
              <div className="border-0" style={{ padding: "10px 0 0 0" }}>
                <span>
                  <button
                    className="accordion-button collapsed no-focus-outline"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseUpload"
                    aria-expanded="false"
                    aria-controls="collapseUpload"
                    style={{ padding: "0px 0 10px 0" }}
                  >
                    <span
                      className="review-text menu-options"
                      style={{ padding: "0" }}
                    >
                      Upload Date
                    </span>
                  </button>
                </span>
                <div
                  id="collapseUpload"
                  className="accordion-collapse collapse sub-text px-2"
                  data-bs-parent="#filterUpload"
                >
                  <div>
                    <label>Start Date</label>
                    <input
                      className="form-control"
                      type="date"
                      name="startDate"
                      max={new Date().toISOString().split("T")[0]}
                      onChange={(e) =>
                        props.handleFilterChange("startDate", e.target.value)
                      }
                    />
                  </div>
                  <div>
                    <label>End Date</label>
                    <input
                      className="form-control"
                      type="date"
                      name="endDate"
                      min={props.filters.startDate || null} // Cannot be before start date
                      max={new Date().toISOString().split("T")[0]}
                      onChange={(e) =>
                        props.handleFilterChange("endDate", e.target.value)
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </>
  );
}
